import axios from "axios";
import baseURL from "../config/api";

export const post_UserLogin = (data: any) => {
    return axios({
        url: `${baseURL}AuthUser/login`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const post_MemberLogin = (data: any) => {
    return axios({
        url: `${baseURL}AuthMember/login`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const post_MemberLoginByEmail = async (data: any) => {
    return await axios({
        url: `${baseURL}AuthMember/loginByEmail`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}